import { frontendURL } from 'dashboard/helper/URLHelper';
import PlanesPage from './pages/PlanesPage.vue';

// Página "Planes" en el menú lateral (Victor 2026-06-07), entre Informes y Leads.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/planes'),
    name: 'planes_home',
    component: PlanesPage,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
